import React from "react";
import { parseOrderData } from "util/helpers";

// Some older orders will only have service objects,
// newer orderes will have data stored in the note_attributes
export default function OrderCollectionDate({ order }) {
  const { collectionDate, pickupTime } = parseOrderData(order);

  if (!collectionDate) {
    return "";
  }

  // Function to format time from service window (e.g., "12pm - 2pm" -> "12:00 PM")
  const formatServiceTime = (serviceHour) => {
    if (!serviceHour) return null;

    // Split by " - " and take the first part (start time)
    const startTime = serviceHour.split(" - ")[0];
    if (!startTime) return null;

    // Parse the time (e.g., "12pm" -> "12:00 PM")
    const match = startTime.match(/^(\d{1,2})(am|pm)$/i);
    if (match) {
      const hour = match[1];
      const period = match[2].toUpperCase();
      return `${hour}:00 ${period}`;
    }

    // If it doesn't match expected format, return as-is
    return startTime;
  };

  // Use the service.hour directly and format it
  const serviceHour = order.service?.hour;
  const formattedServiceTime = formatServiceTime(serviceHour);

  const time =
    pickupTime ||
    formattedServiceTime ||
    collectionDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    // <span>{time} - </span>
    <span>
      {time}
      <br />
      {collectionDate.toLocaleDateString()}
    </span>
  );
}
